import { WizTranslationConfigurationObj } from '@wizeoo/akm-core-lib';
import { WizTranslationManager } from '../../../services/translation/wiz-translation.manager';
import { WizCommand } from './wiz-command';

/** translation initialization command */
export class WizInitTranslationCommand extends WizCommand<any> {

    /** Application default configuration for translations */
    private _configuration: WizTranslationConfigurationObj;

    /** Application default configuration for translations */
    private _initLocale: string;

    /**
     * constructor
     * @param pTranslationConfVO Application default configuration for translations
     * @param pInitLocale First locale loaded
     */
    constructor(pTranslationConfVO: WizTranslationConfigurationObj, pInitLocale: string) {
        super();
        this._configuration = pTranslationConfVO;
        this._initLocale = pInitLocale;
    }

    public async wizExecute(): Promise<any> {
        // Translation init with default locale en if not set by constructor
        if (!this._configuration) {
            this._configuration = new WizTranslationConfigurationObj();
            this._configuration.separator = '=';
        }
        WizTranslationManager.getInstance().configure(this._configuration);
        return WizTranslationManager.getInstance().loadTranslations(this._initLocale);
    }
}
